import React from "react";
import Appointments from "../components/Appointments";

const AppointmentsScreen = (props) => {
  return <Appointments {...props} />;
};
export default AppointmentsScreen;
